import moment from 'moment'

import { BaseModel } from '../base-model'
import { ActionHistoryData } from './action-history.data'

export class ActionHistoryModel extends BaseModel {
  action: string
  data: {
    authorizationId?: string
    errors?: Array<{ errorMessage: string }>
    sourceApi?: string
  }
  createdAt: moment.Moment

  constructor(data: ActionHistoryData) {
    super(data, true)
  }
}
